<h1 mat-dialog-title>{{data.heading}}</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>
</div>
<div mat-dialog-actions>
  <button class="btn-primary float-right" mat-button [mat-dialog-close]="true" cdkFocusInitial>{{data.ok}}</button>
</div>
